export default "__VITE_ASSET__B$bvNA1N__"